import React, { useEffect, useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import Login from '../screens/Login';
import Register from '../screens/Register';
import Read from '../screens/Read';
import Settings from '../screens/Settings';
import Main from '../screens/Main';
import PrivacyPolicy from '../screens/PrivacyPolicy';
import UseOfTerms from '../screens/UseOfTerms';
import CookiePolicy from '../screens/CookiePolicy';
import FAQUI from '../contents/FAQUI';
import WelcomeUI from '../contents/WelcomeUI';
import PaymentSecurity from '../components/PaymentSecurity';
import BuyBookProblem from '../screens/BuyBookProblem';
import OfflinePage from '../screens/OfflinePage'; // Import OfflinePage

import AnalyticsTracker from '../AnalyticsTracker';

const RoutesComponent = ({ user }) => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  // If offline, still redirect to the OfflinePage specifically
  // This ensures that if the user is truly offline, they are always directed there.
  if (!isOnline) {
    return <OfflinePage />;
  }

  return (
    <>
      <AnalyticsTracker />
      <Routes>
        <Route path="/" element={user ? <Main /> : <WelcomeUI />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/read/:bookId" element={user ? <Read /> : <Navigate to="/login" />} />
        <Route path="/settings" element={user ? <Settings /> : <Navigate to="/login" />} />
        <Route path="/payment-security" element={user ? <PaymentSecurity /> : <Navigate to="/login" />} />

        {/* New route for OfflinePage so users can access saved audio when online */}
        {/* You might want to protect this route if offline audio is only for logged-in users */}
        <Route path="/saved-audio" element={<OfflinePage />} />

        {/* Ашық беттер */}
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-use" element={<UseOfTerms />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
        <Route path="/buy-book-problem" element={<BuyBookProblem />} />
        <Route path="/faq" element={<FAQUI />} />
        <Route path="/welcome" element={<WelcomeUI />} />

        {/* Барлық басқа маршруттар басты бетке бағытталады */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </>
  );
};

export default RoutesComponent;